const stripTrailingSlash = (url: string) => url.replace(/\/+$/, "");

const resolveApiBaseUrl = (): string => {
  const configured = process.env.NEXT_PUBLIC_API_URL?.trim();
  if (configured) return stripTrailingSlash(configured);

  if (process.env.NODE_ENV === "production") {
    console.error(
      "NEXT_PUBLIC_API_URL is not set - falling back to same-origin API requests."
    );
    return "";
  }

  return "http://localhost:8076";
};

/** Base URL of the backend API, without a trailing slash. */
export const API_BASE_URL = resolveApiBaseUrl();

/** Request timeout applied to the shared axios instance. */
export const API_TIMEOUT_MS = Number(
  process.env.NEXT_PUBLIC_API_TIMEOUT_MS || 30000
);
